export const AUTH_TOKEN = 'token_user_vida_longa'
export const USER_AUTHENTICATED = 'user_vida_longa'

